import 'hammerjs';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CuiSwipeableActionDirective } from './swipeable-action.directive';
import { CuiSwipeableComponent } from './swipeable.component';
import {MatIconModule} from '@angular/material';
import {CuiIconModule} from '../icon/icon.module';

@NgModule({
  imports: [
    BrowserModule,
    MatIconModule,
    CuiIconModule
  ],
  declarations: [
    CuiSwipeableActionDirective,
    CuiSwipeableComponent
  ],
  exports: [
    CuiSwipeableActionDirective,
    CuiSwipeableComponent
  ]
})
export class CuiSwipeableModule {}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/swipeable/swipeable.module.ts